export default __webpack_public_path__ + "static/media/in-location.4075bda3.svg";